// One note-slug derivation for every surface. The CLI (deriveNoteSlug) and the
// MCP (deriveNoteName) shipped two near-identical copies; this is the canonical
// one. A stable, readable id: first 6 words of the title-or-content, kebab-cased,
// with a short random suffix so two identical notes never collide.
export function deriveNoteSlug(content: string, opts?: { title?: string; suffix?: string }): string {
  const source = (opts?.title && opts.title.trim()) || content
  const head = source.trim().split(/\s+/).slice(0, 6).join(' ')
  const base = head
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
  const rand = opts?.suffix ?? Math.random().toString(36).slice(2, 8)
  return `${base || 'note'}-${rand}`
}
